// Toucan Stop Words
import stopWords from './stop-words.json'

var T_SW = function () {
  var self = this
  this.words = JSON.parse(JSON.stringify(stopWords))

  // Stop words - words filter out before processing, eg it, the, them, is,
  // Regex looks for isolated stop words to be removed froma senetence or response string.
  // Regex specificlallly looks for '(^|\\s) beginning of sentence (stop word list) (?![a-z\'`’]) anything that is not apostrophe or alpha
  // eg have'nt would match with "have" stop word
  this.regex = new RegExp('(^|\\s)(' + self.words.join('|') + ')(?![a-z\'`’])', 'gi')
  // this.regex = new RegExp('(?<![a-z\'`’])(' + self.words.join('|') + ')(?![a-z\'`’])', 'gi')
  // Use this ^ when FireFox 78 gets use more. ?<! negative lookbehinds arent supported before this for FF
}

T_SW.prototype.clean = function (str) {
  return str.replace(/([^a-z0-9'’`])/ig, ' ')
    .replace(this.regex, '')
    .replace(/(\s'*(\s|$))/ig, ' ')
    .toLowerCase().trim()
}

T_SW.prototype.generateTopBigrams = function (arr, termsCount) {
  var that = this
  var bigramsCount = {}

  arr.forEach(function (r) {
    if (!r.show) return

    var words = that.clean(r.content).split(/\s/)
    var seenBigrams = new Set()

    words.forEach(function (w, index) {
      if (w.length < 2) return

      // Generate possible vigram
      var bigram = false
      if (index > 0 && words[index - 1].length > 1) bigram = words[index - 1] + ' ' + w

      // Check we have bigram and is not repeated
      if (!bigram || seenBigrams.has(bigram)) return

      seenBigrams.add(bigram)

      if (bigram in bigramsCount) bigramsCount[bigram] += 1
      else bigramsCount[bigram] = 1
    })
  })

  // Only add bigrams with a count >= 5
  for (const k in bigramsCount) {
    if (bigramsCount[k] >= 5) termsCount[k] = bigramsCount[k]
  }
}

T_SW.prototype.generateTermFreq = function (arr, termsCount) {
  var that = this
  // Add the top bigrams into the termCount obj
  this.generateTopBigrams(arr, termsCount)

  arr.forEach(function (r) {
    if (!r.show) return

    termsCount.responses_count++
    var words = that.clean(r.content).split(/\s/)

    var seenWord = new Set()
    words.forEach(function (w, index) {
      if (w.length < 2) return

      // Generate possible Bigram
      var bigram1 = false
      var bigram2 = false
      if (index > 0 && words[index - 1].length > 1) bigram1 = words[index - 1] + ' ' + w
      if (index < words.length - 1 && words[index + 1].length > 1) bigram2 = w + ' ' + words[index + 1]

      // Do not increment if the word belongs to a top bigram or is one character
      if ((bigram1 && bigram1 in termsCount) || (bigram2 && bigram2 in termsCount) || seenWord.has(w)) return
      seenWord.add(w)

      // Increment count for the word
      if (w in termsCount) termsCount[w] += 1
      else termsCount[w] = 1
    })
  })
}

export default T_SW
